import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import moment from "moment"

import {Wallet} from "@irati/types"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"
import id from "@irati/utils/id"

import Wrapper from "../Wrapper"
import Location from "../Location"
import Online from "../Online"
import SecondaryDetailsItem from "../Item"
import {StyledRouterLink, StyledIconText} from "./styled/Cashback"

interface Data {
  location?: string
  transactionAmount?: number
  transactionDate?: string
  lastFour?: number
  dealHeader?: string
  dealUrlSlug?: string
  isPerksGoRetailDeal?: boolean
}

interface Props extends InjectIntl {
  className?: string
  data: Data
  wallet: Wallet
}

class Cashback extends PureComponent<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  getTransactionDescription = (transactionAmount: number | undefined, lastFour: number | undefined, currency: string) => {
    if (!transactionAmount || !lastFour || !currency) {
      return null
    }

    return (
      <FormattedMessage
        id="wallet.secondaryDetails.perksGO.cashback.transactionDescription"
        values={{
          amount: this.props.intl.formatNumber(transactionAmount, {style: "currency", currency}),
          lastFour
        }}
      />
    )
  }

  render() {
    const {className, data, wallet, formatMessage} = this.props
    const {apps} = this.context
    const {location, transactionAmount, transactionDate, lastFour, dealUrlSlug, isPerksGoRetailDeal} = data
    const {currency} = wallet
    const idNamespace = id("secondary-details-perksGO-cashback", this.props)
    const transactionDescriptionText = this.getTransactionDescription(transactionAmount, lastFour, currency)
    const formattedTransactionDate = moment(transactionDate).format("dddd, Do MMMM YYYY, h:mm A")

    return (
      <Wrapper className={className} id={idNamespace}>
        {location && !isPerksGoRetailDeal && <Location text={location} />}
        {isPerksGoRetailDeal && <Online text={formatMessage({id: "wallet.secondaryDetails.perksGO.cashback.onlineText"})} />}
        {transactionDescriptionText && <SecondaryDetailsItem text={transactionDescriptionText} />}
        {transactionDate && <SecondaryDetailsItem text={formattedTransactionDate} />}
        {dealUrlSlug && (
          <StyledRouterLink app={apps.PERKS} to={`/info/${dealUrlSlug}`} id={id("deal-button", idNamespace)} uppercase={false}>
            <StyledIconText icon="angleRight" iconPosition="right">
              <FormattedMessage id="wallet.secondaryDetails.perksGO.cashback.dealButtonText" />
            </StyledIconText>
          </StyledRouterLink>
        )}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({wallet}: ReduxState) => ({
  wallet
})

export default injectIntl(connect(mapStateToProps)(Cashback))
